// Configuration Telegram Bot pour NSA SERVICES
// Configuration pour recevoir automatiquement les bons de réservation

export const TELEGRAM_CONFIG = {
  // Token du bot Telegram de NSA SERVICES (obtenu via @BotFather)
  BOT_TOKEN: '8374879391:AAF_1VJKk59K5MKTsuUOKiTk0kRtku__eYo',
  
  // Chat ID de NSA SERVICES pour recevoir les bons de réservation
  CHAT_ID: '1252831439',
  
  // Message automatique pour chaque bon reçu
  DEFAULT_MESSAGE: 'NSA SERVICES - Nouvelle réservation reçue'
};

// Instructions pour NSA SERVICES :
// 1. Créer un bot NSA SERVICES : Envoyer /newbot à @BotFather sur Telegram
// 2. Nommer le bot : "NSA Services Bot" ou similaire
// 3. Obtenir le token : BotFather vous donnera un token (ex: 123456789:ABCdefGHIjklMNOpqrsTUVwxyz)
// 4. Obtenir le Chat ID de NSA SERVICES :
//    - Envoyer un message au bot depuis le compte Telegram de NSA SERVICES
//    - Visiter : https://api.telegram.org/bot<VOTRE_TOKEN>/getUpdates
//    - Copier l'ID du chat (nombre dans "chat":{"id":123456789})
// 5. Configurer ce fichier avec vos informations
// 6. Tester : Chaque réservation sera automatiquement envoyée à NSA SERVICES
